"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeSequence = initializeSequence;
exports.prepareSequence = prepareSequence;
exports.startSequence = startSequence;
exports.makeStateful = makeStateful;
Object.defineProperty(exports, "Feature", {
  enumerable: true,
  get: function get() {
    return _feature.Feature;
  }
});
Object.defineProperty(exports, "Helper", {
  enumerable: true,
  get: function get() {
    return _helper.Helper;
  }
});
exports.stringUtils = exports.propUtils = exports["default"] = exports.stages = exports.INITIALIZE_FAILURE = exports.PREPARE_FAILURE = exports.START_FAILURE = exports.RUNNING = exports.STARTING = exports.READY = exports.PREPARING = exports.INITIALIZED = exports.INITIALIZING = exports.createSingleton = exports.Runtime = exports.events = exports.features = exports.helpers = exports.createRegistry = exports.registerHelper = exports.ContextRegistry = exports.pathUtils = exports.urlUtils = exports.observableMap = void 0;

var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("@babel/polyfill/noConflict");

var _lodash = _interopRequireDefault(require("lodash"));

var mobx = _interopRequireWildcard(require("mobx"));

var _path = require("path");

var _querystring = require("querystring");

var _url = require("url");

var _uuid = _interopRequireDefault(require("uuid"));

var _cache = _interopRequireDefault(require("./cache"));

var _feature = require("./feature");

var _profiler = _interopRequireDefault(require("./features/profiler"));

var _vm = _interopRequireDefault(require("./features/vm"));

var _helper = require("./helper");

var _emitter = require("./utils/emitter");

var _mware = _interopRequireDefault(require("./utils/mware"));

var propUtils = _interopRequireWildcard(require("./utils/properties"));

exports.propUtils = propUtils;

var stringUtils = _interopRequireWildcard(require("./utils/string"));

exports.stringUtils = stringUtils;

var _weakCache = _interopRequireDefault(require("./weak-cache"));

var propertyUtils = propUtils.propertyUtils;
var observableMap = mobx.observable.map;
exports.observableMap = observableMap;
var urlUtils = {
  parseUrl: _url.parse,
  formatUrl: _url.format,
  parseQueryString: _querystring.parse
};
exports.urlUtils = urlUtils;
var pathUtils = {
  join: _path.join,
  parse: _path.parse,
  resolve: _path.resolve,
  sep: _path.sep,
  basename: _path.basename,
  dirname: _path.dirname,
  relative: _path.relative
};
exports.pathUtils = pathUtils;
var ContextRegistry = _helper.Helper.ContextRegistry;
exports.ContextRegistry = ContextRegistry;
var _registerHelper = _helper.Helper.registerHelper;
exports.registerHelper = _registerHelper;
var createRegistry = _helper.Helper.createRegistry;
exports.createRegistry = createRegistry;
var helpers = _helper.Helper.registry;
exports.helpers = helpers;
var features = _feature.Feature.registry;
exports.features = features;
var events = (0, _emitter.attachEmitter)({});
exports.events = events;
var camelCase = stringUtils.camelCase,
    snakeCase = stringUtils.snakeCase;
var _hashObject = propUtils.hashObject,
    entity = propUtils.createEntity,
    hide = propUtils.hide,
    enhanceObject = propUtils.enhanceObject;
var _observe = mobx.observe,
    extendObservable = mobx.extendObservable,
    observable = mobx.observable,
    toJS = mobx.toJS,
    computed = mobx.computed,
    action = mobx.action,
    autorun = mobx.autorun;
var selectorCache = new WeakMap();
var _result = _lodash["default"].result,
    keys = _lodash["default"].keys,
    pick = _lodash["default"].pick,
    _get = _lodash["default"].get,
    isFunction = _lodash["default"].isFunction,
    omitBy = _lodash["default"].omitBy,
    mapValues = _lodash["default"].mapValues,
    toPairs = _lodash["default"].toPairs,
    zipObjectDeep = _lodash["default"].zipObjectDeep,
    uniq = _lodash["default"].uniq,
    castArray = _lodash["default"].castArray,
    defaults = _lodash["default"].defaultsDeep,
    isArray = _lodash["default"].isArray,
    isObject = _lodash["default"].isObject,
    isUndefined = _lodash["default"].isUndefined,
    flatten = _lodash["default"].flatten;
var runtimesRegistry;
var frameworkRuntime;
var singleton;
var windowIsAvailable = typeof window !== 'undefined';
var documentIsAvailable = typeof document !== 'undefined';
var processIsAvailable = typeof process !== 'undefined';

var defaultOptions = _result(global, 'SkypagerDefaultOptions', {});

var defaultContext = _result(global, 'SkypagerDefaultContext', {});

var contextTypes = _result(global, 'SkypagerContextTypes', {});

var optionTypes = _result(global, 'SkypagerOptionTypes', {});

var enableStrictMode = _get(global, 'process.env.SKYPAGER_STRICT_MODE', _get(global, 'SkypagerStrictMode', false));
/**
 * @typedef {Object<string, function>} Mixin
 */

/**
 *
 * @typedef {Object<string>} MixinOptions
 * @prop {Array} partial - an array of objects to be passed as arguments to the function
 * @prop {Boolean} right - whether to append the arguments
 * @prop {Boolean} insertOptions - whether to pass an empty object as the first arg automatically
 * @prop {Boolean} hidden - make the property non-enumerable
 * @prop {Boolean} configurable - make the property non-configurable
 */

/**
 *
 * @typedef {Object} Logger
 * @prop {Function} log
 * @prop {Function} info
 * @prop {Function} debug
 * @prop {Function} warn
 * @prop {Function} error
 */

/**
 * @mixin Stateful
 * @property {Map} state
 * @property {Object} currentState
 * @property {Function} setState
 * @property {Function} replaceState
 * @property {String} cacheKey
 * @property {String} stateHash
 */

/**
 * Create a new instance of the skypager.Runtime
 *
 * @class Runtime
 * @classdesc The Runtime is similar to the window or document global in the browser, or the module / process globals in node.
 * You can extend Runtime and define your own process global singleton that acts as a state machine, event emitter,
 * module registry, dependency injector.  Typically you can just do this with features instead of subclassing.
 * @mixes Stateful
 * @param {object} [options] - the props, or argv, for the runtime instance at the time it is created
 * @param {object} [context] - the context, environment, static config, or similar global values that may be relevant to some component in the runtime
 * @param {function} [middlewareFn] - this function will be called when the runtime is asynchronously loaded and the plugins have run *
 */


var Runtime =
/*#__PURE__*/
function () {
  function Runtime() {
    var _middlewares,
        _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var middlewareFn = arguments.length > 2 ? arguments[2] : undefined;
    (0, _classCallCheck2["default"])(this, Runtime);
    (0, _defineProperty2["default"])(this, "displayName", 'Skypager');
    (0, _defineProperty2["default"])(this, "stateVersion", 0);
    (0, _defineProperty2["default"])(this, "Helper", _helper.Helper);
    (0, _defineProperty2["default"])(this, "Feature", _feature.Feature);

    if (isFunction(options)) {
      middlewareFn = options;
      options = {};
      context = context || {};
    }

    if (isFunction(context)) {
      middlewareFn = context;
      context = {};
    }

    enhanceObject(this, {
      propUtils: false,
      includeLodashMethods: false,
      includeChain: false
    }, _lodash["default"]);
    (0, _emitter.attachEmitter)(this);
    extendObservable(this, {
      state: observable.shallowMap(toPairs(this.initialState)),
      currentState: computed(this.getCurrentState.bind(this)),
      stateHash: computed(this.getStateHash.bind(this)),
      cacheKey: computed(this.getCacheKey.bind(this)),
      setState: action(this.setState.bind(this)),
      replaceState: action(this.replaceState.bind(this)),
      featureStatus: observable.shallowMap([])
    });

    var cwd = _result(options, 'cwd', function () {
      return !isUndefined(process) ? _result(process, 'cwd', '/') : '/';
    });

    this.hideProperties({
      _logger: console,
      _parent: context.parent || singleton,
      _cwd: cwd,
      _uuid: (0, _uuid["default"])(),
      _name: options.name || camelCase(snakeCase(cwd.split('/').pop())),
      _cache: new _cache["default"](options.cacheData || []),
      _weakCache: new _weakCache["default"](options.cacheData || []),
      rawOptions: options,
      rawContext: context,
      _enabledFeatures: {},
      middlewares: (_middlewares = {}, (0, _defineProperty2["default"])(_middlewares, STARTING, (0, _mware["default"])(this)), (0, _defineProperty2["default"])(_middlewares, PREPARING, (0, _mware["default"])(this)), _middlewares),
      _registries: new ContextRegistry('registries', {
        context: _helper.Helper.createMockContext({})
      }),
      _selectors: new ContextRegistry('selectors', {
        context: _helper.Helper.createMockContext({})
      })
    });
    var start = this.start,
        initialize = this.initialize,
        prepare = this.prepare;
    if (isFunction(options.initialize)) initialize = _lodash["default"].flow(this.initialize, options.initialize);
    if (isFunction(options.prepare)) prepare = _lodash["default"].flow(this.prepare, options.prepare);
    this.initialize = initializeSequence.bind(this, this, initialize);
    this.prepare = prepareSequence.bind(this, this, prepare);
    this.start = startSequence.bind(this, this, start);
    this.events.emit('runtimeWasCreated', this, this.constructor);
    this.applyRuntimeInitializers(); // autoAdd refers to require.contexts that should be added to our registries
    // this step is deferred until all helpers have been attached.

    this.constructor.autoAdd.forEach(function (item) {
      var type = item.type,
          ctx = item.ctx;

      _this.invoke("".concat(type, ".add"), ctx);
    });
    this.attachAllHelpers();

    _feature.Feature.attach(this);

    this.features.register('profiler', function () {
      return {
        "default": _profiler["default"]
      };
    });
    this.features.register('vm', function () {
      return _vm["default"];
    });
    this.enableFeatures(this.autoEnabledFeatures);

    if (typeof middlewareFn === 'function') {
      this.use(middlewareFn.bind(this), INITIALIZING);
    }

    if (this.autoInitialize) this.initialize();
  }
  /**
   * Extend the runtime with a middleware function, plugin object, or helper class.
   *
   * @example chain them as necessary
   *
   * runtime
   *  .use((next) => { })
   *  .use({ attach(runtime) { } })
   *  .use(MyFeature)
   *  .use('some-feature-thats-been-registered')
   *
   * @example using a function, deferred until runtime.start() is called
   *
   * runtime.use((next) => {
   *  doSomethingAsync().then(() => next()).catch((error) => next(error))
   * })
   *
   * @example using a plugin object with an attach function
   *
   * runtime.use({
   *  attach(runtime) {
   *    console.log('runs immediately')
   *    runtime.use((next) => {
   *      console.log('called at runtime start() like normal')
   *    })
   *  }
   * })
   *
   * @example specifying the PREPARING stage to run before any starting middlewares are called
   *
   * runtime
   *  .use(runOnStart)
   *  .use(runBeforeStart, 'PREPARING')
   *
   * @example using a feature class will register and enable the feature
   *
   * export default class MyFeature extends Feature {
   *  featureId = 'registered-in-the-registry-with-this'
   *
   *  featureWasEnabled(config) {
   *    console.log('enabled with', config) // enabled with { option: 'passed to feature enable' }
   *  }
   * }
   *
   * // in another module
   * import MyFeature from 'myFeature'
   *
   * runtime.use(MyFeature, { option: 'passed to feature enable' })
   *
   * @example passing a string which refers to an already existing feature
   *
   * runtime.use('some-registered-feature')
   *
   * @memberof Runtime
   * @param {Function|Object|Feature|Helper} extension an object that meets the requirements to be an extension
   * @param {String|Object} [stage=INITIALIZING] which stage to run this middleware in (INITIALIZING, PREPARING, STARTING)
   * @returns {Runtime}
   */


  (0, _createClass2["default"])(Runtime, [{
    key: "use",
    value: function use(extension, stage) {
      var runtime = this;

      if (isObject(extension) && isFunction(extension.initializer)) {
        return this.use(extension.initializer.bind(this), INITIALIZING);
      } else if (isFunction(extension) && extension.isSkypagerFeature) {
        var featureId = extension.featureId || extension.shortcut || extension.prototype.shortcut || extension.name;

        if (!this.features.checkKey(featureId)) {
          this.features.register(featureId, function () {
            return extension;
          });
          var myFeature = this.feature(featureId, isObject(stage) ? (0, _objectSpread2["default"])({}, this.options, stage) : this.options);
          myFeature.enable((0, _objectSpread2["default"])({}, this.options, isObject(stage) ? stage : {}));
          return this;
        }
      } else if (isObject(extension) && isFunction(extension.attach)) {
        extension.attach.call(this, this, isObject(stage) ? (0, _objectSpread2["default"])({}, this.options, stage) : this.options, this.context);
      } else if (isObject(extension) && extension["default"]) {
        return this.use(extension["default"], stage);
      }

      var m = extension.middleware || extension.use;

      if (isObject(extension) && isFunction(m)) {
        extension = m;
      }

      if (typeof extension === 'string') {
        if (runtime.availableFeatures.indexOf(extension) >= 0) {
          var _featureId = extension;

          extension = function extension() {
            return runtime.feature(_featureId).enable();
          };

          stage = stage || INITIALIZING;
        } else {
          try {
            console.error("Can not do dynamic requires anymore: You tried: ".concat(extension));
          } catch (error) {}
        }
      }

      if (isFunction(extension) && stage === INITIALIZING) {
        extension.call(runtime, function (err) {
          if (err) {
            runtime.error(err.message || "Error while using extension ".concat(extension.name), {
              error: err
            });
            throw err;
          }
        });
        return this;
      }

      if (typeof extension !== 'function') {
        return this;
      }

      if (typeof stage === 'undefined' && this.isPrepared) {
        stage = STARTING;
      }

      var pipeline = runtime.result(['middlewares', stage || STARTING], function () {
        var p = (0, _mware["default"])(runtime);
        runtime.set(['middlewares', stage || STARTING], p);
        return p;
      });
      pipeline.use(extension.bind(runtime));
      return this;
    }
  }, {
    key: "lazy",

    /**
     * Creates a lazy loading property on an object.
     *
     * @param {String} attribute The property name
     * @param {Function} fn The function that will be memoized
     * @param {Boolean} enumerable Whether to make the property enumerable when it is loaded
     * @return {Helper#}
     */
    value: function lazy(attribute, fn) {
      var enumerable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return propertyUtils(this).lazy(attribute, fn, enumerable);
    }
    /**
     * creates a non enumerable property on the target object
     *
     * @param {String} attribute
     * @param {*} value
     * @param {Object} options
     * @memberof Helper#
     *
     */

  }, {
    key: "hide",
    value: function hide(attribute, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return propertyUtils(this).hide(attribute, value, options);
    }
    /**
     * creates a non enumerable property on the helper
     *
     * @param {String} attribute
     * @param {*} value
     * @param {Object} options
     * @memberof Helper#
     *
     */

  }, {
    key: "hideProperty",
    value: function hideProperty(attribute, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return propertyUtils(this).hide(attribute, value, options);
    }
    /**
     * creates multiple non-enumerable properties on the helper
     *
     * @param {Object<string,object>} properties
     * @memberof Helper#
     *
     */

  }, {
    key: "hideProperties",
    value: function hideProperties() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return propertyUtils(this).hideProperties(properties);
    }
    /**
     * Create a hidden getter property on the object.
     *
     * @param {String} attribute    The name of the property
     * @param {Function} fn      A function to call to return the desired value
     * @param {Object} [options={}]
     * @param {Object} [options.scope=this]
     * @param {Array} [options.args=[]] arguments that will be passed to the function
     * @memberof Helper#
     * @return {Helper#}
     */

  }, {
    key: "hideGetter",
    value: function hideGetter(attribute, fn) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return propertyUtils(this).hideGetter(attribute, fn, options);
    }
    /**
     * Create a hidden getter property on the object.
     *
     * @param {String} attribute    The name of the property
     * @param {Function} fn      A function to call to return the desired value
     * @param {Object} [options={}]
     * @param {Object} [options.scope=this]
     * @param {Array} [options.args=[]] arguments that will be passed to the function
     * @memberof Helper#
     * @return {Helper}
     */

  }, {
    key: "getter",
    value: function getter(attribute, fn) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return propertyUtils(this).getter(attribute, fn, options);
    }
    /**
     * @param {Mixin} methods - an object of functions that will be applied to the target
     * @param {MixinOptions} options - options for the mixin attributes
     */

  }, {
    key: "applyInterface",
    value: function applyInterface() {
      var methods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return propertyUtils(this).applyInterface(methods, options);
    }
  }, {
    key: "at",
    value: function at() {
      for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
        paths[_key] = arguments[_key];
      }

      return _lodash["default"].at.apply(_lodash["default"], [this].concat(paths));
    }
    /**
     * Set the value at an object path. Uses lodash.set
     *
     * @param {*} path
     * @param {*} value
     * @returns {?}
     * @memberof Runtime
     */

  }, {
    key: "set",
    value: function set(path, value) {
      return _lodash["default"].set(this, path, value);
    }
    /**
     * Get the value at an object path.  Uses lodash.get
     *
     * @param {String} path
     * @param {*} defaultValue
     * @returns {?}
     * @memberof Runtime
     */

  }, {
    key: "get",
    value: function get(path, defaultValue) {
      return _get(this, path, defaultValue);
    }
    /**
     * Get the value at an object path. If that path is a function, we'll call it.
     * Uses lodash.result
     *
     * @param {*} path
     * @param {*} defaultValue
     * @returns {?}
     * @memberof Runtime
     */

  }, {
    key: "result",
    value: function result(path, defaultValue) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return _result.apply(void 0, [this, path, defaultValue].concat(args));
    }
    /**
     * Check if runtime has a property
     *
     * @param {*} path
     * @param {*} defaultValue
     * @returns {Boolean}
     * @memberof Runtime
     */

  }, {
    key: "has",
    value: function has(path) {
      return _lodash["default"].has(this, path);
    }
    /**
     * Invoke a function at a nested path
     *
     * @param {*} functionAtPath
     * @param {...*} args
     * @returns {?}
     * @memberof Runtime
     */

  }, {
    key: "invoke",
    value: function invoke(functionAtPath) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return _lodash["default"].invoke.apply(_lodash["default"], [this].concat(args));
    }
  }, {
    key: "pick",
    value: function pick() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _lodash["default"].pick.apply(_lodash["default"], [this].concat(args));
    }
    /**
      The Context Types API defines a schema for properties that will be made available via the runtime's context system.
       You can specify your own context types when you are extending the Runtime class.  If you are using Skypager as
      a global singleton, you won't have the opportunity if you just require('skypager-runtime'), so you can define
      a global variable SkypagerContextTypes and it will use these instead.
    */

  }, {
    key: "spawn",

    /**
     * Spawn a new Runtime instance
     *
     * @param {Object} [options={}]
     * @param {Object} [context={}]
     * @param {Function} [middlewareFn]
     * @returns {Runtime}
     * @memberof Runtime
     */
    value: function spawn() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var middlewareFn = arguments.length > 2 ? arguments[2] : undefined;

      if (isFunction(options)) {
        middlewareFn = options;
        options = {};
        context = context || {};
      }

      if (isFunction(context)) {
        middlewareFn = context;
        context = {};
      }

      return this.constructor.spawn(options, context, middlewareFn);
    }
  }, {
    key: "registerRuntime",
    value: function registerRuntime() {
      var _this$constructor;

      return (_this$constructor = this.constructor).registerRuntime.apply(_this$constructor, arguments);
    }
    /**
     * If you have code that depends on a particular helper registry being available
     * on the runtime, you can pass a callback which will run when ever it exists and
     * is ready.  This is useful for example, when developing a feature which includes a
     * client and a server helper to go along with it.  If the runtime is web, you wouldn't
     * have a server helper so you wouldn't want to load that code.  If the same runtime is
     * used on a server, then you would run that code.
     *
     * @param {string} registryPropName - the name of the registry you want to wait for
     * @param {Function} callback - a function that will be called with runtime, the helperClass, and the options passed when attaching that helper
     * @memberof Runtime#
     *
     * @example @lang js <caption>Conditionally running code when the servers helper is attached</caption>
     *
     * runtime.onRegistration("servers", () => {
     *  runtime.servers.register('my-server', () => require('./my-server'))
     * })
     *
     */

  }, {
    key: "onRegistration",
    value: function onRegistration(registryPropName, callback) {
      // to refactor the dynamic method attachment of various helpers,
      // i an prefixing their names with _ and then creating actual properties
      // on runtime so that I can jsdoc them
      registryPropName = registryPropName.replace(/^_/, '');

      if (typeof callback !== 'function') {
        throw new Error('Must pass a callback');
      }

      var alreadyRegistered = this.has(registryPropName);

      if (!alreadyRegistered) {
        _helper.Helper.events.on('attached', function (runtime, helperClass) {
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          var _ref = options || {},
              _ref$registry = _ref.registry,
              registry = _ref$registry === void 0 ? {} : _ref$registry;

          if (registry && registry.name === registryPropName) {
            callback(null, runtime, helperClass, options);
          }
        });

        return;
      }

      var isValidHelper = this.helpers.checkKey(registryPropName) || this.helpers.checkKey(stringUtils.singularize(registryPropName));

      if (!isValidHelper) {
        callback(new Error("".concat(registryPropName, " does not appear to be a valid helper")));
      } else {
        callback(null, this, this.helpers.lookup(isValidHelper), {
          registry: this.get(registryPropName)
        });
      }
    }
  }, {
    key: "registerHelper",

    /**
     * Register a Helper class as being available to our Runtime class
     *
     * @param {String} helperName - the name of the helper class
     * @param {Class} helperClass - a subclass of Helper
     *
     * @returns {Class} the helper class you registered
     */
    value: function registerHelper() {
      var _this$constructor2;

      return (_this$constructor2 = this.constructor).registerHelper.apply(_this$constructor2, arguments);
    }
    /**
     * Register a Helper class as being available to this Runtime class
     *
     * @param {String} helperName - the name of the helper class
     * @param {Class} helperClass - a subclass of Helper
     *
     * @returns {Class} the helper class you registered
     */

  }, {
    key: "log",
    value: function log() {
      var _console;

      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      this.emit.apply(this, ['loggingInfo'].concat(args));

      (_console = console).log.apply(_console, args);
    }
  }, {
    key: "warn",
    value: function warn() {
      var _console2, _console3;

      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      this.emit.apply(this, ['loggingWarning'].concat(args));
      console.warn ? (_console2 = console).warn.apply(_console2, args) : (_console3 = console).log.apply(_console3, args);
    }
  }, {
    key: "debug",
    value: function debug() {
      var _console4, _console5;

      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      this.emit.apply(this, ['loggingDebug'].concat(args));
      console.debug ? (_console4 = console).debug.apply(_console4, args) : (_console5 = console).log.apply(_console5, args);
    }
  }, {
    key: "error",
    value: function error() {
      var _console6, _console7;

      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      this.emit.apply(this, ['loggingError'].concat(args));
      console.error ? (_console6 = console).error.apply(_console6, args) : (_console7 = console).log.apply(_console7, args);
    }
  }, {
    key: "info",
    value: function info() {
      var _console8, _console9;

      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      this.emit.apply(this, ['loggingInfo'].concat(args));
      console.info ? (_console8 = console).info.apply(_console8, args) : (_console9 = console).log.apply(_console9, args);
    }
  }, {
    key: "applyRuntimeInitializers",

    /**
     * A Runtime class will have certain initializer functions that it runs automatically
     * as part of the startup lifecycle, which initializers will be dependent on the target (e.g. node, web)
     * as well as the NODE_ENV environment (production, development, test)
     *
     * @private
     */
    value: function applyRuntimeInitializers() {
      var _this2 = this;

      var mapValues = this.lodash.mapValues;
      var matches = this.runtimeInitializers;

      _helper.Helper.attachAll(this, this.helperOptions);

      mapValues(matches, function (fn, id) {
        try {
          _this2.use(fn.bind(_this2), INITIALIZING);
        } catch (error) {
          _this2.error("Error while applying initializer ".concat(id), {
            error: error
          });
        }
      });

      _helper.Helper.attachAll(this, this.helperOptions);

      return this;
    }
    /**
     * Attach all registered helpers to the runtime
     *
     * @private
     * @returns {Runtime}
     */

  }, {
    key: "attachAllHelpers",
    value: function attachAllHelpers() {
      _helper.Helper.attachAll(this, this.helperOptions);

      return this;
    }
    /**
     * A Mixin is an object of functions.  These functions will get created as properties on this instance.
     *
     * @param {Mixin} mixin
     * @param {MixinOptions} options
     */

  }, {
    key: "mixin",
    value: function mixin() {
      var _mixin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.applyInterface(_mixin, (0, _objectSpread2["default"])({
        transformKeys: true,
        scope: this,
        partial: [],
        right: true,
        insertOptions: false,
        hidden: false
      }, options));
      return this;
    }
    /**
     * If you subclass Runtime, you can define your own initialize function which will be called during the constructor phase
     *
     * @abstract
     * @private
     * @memberof Runtime#
     * @returns {Runtime}
     */

  }, {
    key: "initialize",
    value: function initialize() {
      return this;
    }
    /**
     * If you subclass Runtime, you can define your own prepare function which will be called after the constructor phase
     *
     * @abstract
     * @private
     * @returns {PromiseLike<Runtime>}
     * @memberof Runtime#
     */

  }, {
    key: "prepare",
    value: function () {
      var _prepare = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepare() {
        return _prepare.apply(this, arguments);
      }

      return prepare;
    }()
    /**
     * If you subclass Runtime, you can define your own prepare function which will be called after the constructor phase
     *
     * @abstract
     * @private
     * @memberof Runtime#
     * @returns {PromiseLike<Runtime>}
     */

  }, {
    key: "start",
    value: function () {
      var _start = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "runMiddleware",

    /**
     * Any middleware functions which were added to runtime using the use function
     * get pushed onto a queue.  This function runs that queue
     * @private
     */
    value: function runMiddleware(stage) {
      stage = stage || this.stage;
      var runtime = this;
      var pipeline = runtime.get(['middlewares', stage]);

      if (!pipeline) {
        return Promise.resolve(this);
      }

      if (pipeline.getCount() === 0) {
        pipeline.use(function (next) {
          next();
        });
      }

      return new Promise(function (resolve, reject) {
        pipeline.run(function (err) {
          err ? reject(err) : resolve(err);
        });
      });
    }
  }, {
    key: "getStateHash",
    value: function getStateHash() {
      return this.hashObject(this.currentState);
    }
  }, {
    key: "getCurrentState",
    value: function getCurrentState() {
      var convertToJS = this.convertToJS;
      var mapValues = this.lodash.mapValues;
      return this.state.toJSON();
    }
  }, {
    key: "getCacheKey",
    value: function getCacheKey() {
      return "".concat(this.namespace, ":").concat(this.stateVersion);
    }
  }, {
    key: "whenStarted",

    /**
     * Accepts a callback function which will be called when the runtime is started
     *
     * @param {Function} fn
     * @returns {Runtime}
     * @memberof Runtime
     */
    value: function whenStarted(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') {
        return this.whenStartedAsync();
      }

      if (this.isStarted) {
        fn.call(this, this, this.options, this.context);
      } else if (this.isFailed) {
        fn.call(this, this.currentStart.error, this.options, this.context);
      } else {
        this.once('runtimeDidStart', function () {
          return fn.call(_this3, _this3.options, _this3.context);
        });
        this.once('runtimeFailedStart', function (error) {
          return fn.call(_this3, error, _this3.options, _this3.context);
        });
      }

      return this;
    }
    /**
     * Returns a promise that will resolve when the runtime is started.
     *
     * @returns {PromiseLike<Runtime>}
     * @memberof Runtime
     */

  }, {
    key: "whenStartedAsync",
    value: function whenStartedAsync() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        if (_this4.isStarted) {
          resolve(_this4);
          return;
        } else if (_this4.sandbox.isFailed) {
          reject(_this4.currentState.error);
          return;
        }

        _this4.once('runtimeDidStart', function () {
          return resolve(_this4);
        });

        _this4.once('runtimeFailedToStart', function (error) {
          return reject(error);
        });
      });
    }
    /**
     * @alias whenPrepared
     */

  }, {
    key: "whenReady",
    value: function whenReady(fn, onError) {
      return this.whenPrepared(fn, onError);
    }
    /**
     * @alias whenReadyAsync
     */

  }, {
    key: "whenReadyAsync",
    value: function whenReadyAsync() {
      return this.whenPreparedAsync();
    }
    /**
     * Takes a callback which will get called once this runtime is prepared
     *
     * @param {Function} fn
     * @param {Function} onError
     * @returns {PromiseLike<Runtime>}
     * @memberof Runtime
     */

  }, {
    key: "whenPrepared",
    value: function whenPrepared(fn, onError) {
      var _this5 = this;

      if (!isFunction(fn)) {
        return this.whenPreparedAsync();
      }

      try {
        if (this.isPrepared) {
          fn.call(this, this, this.options, this.context);
        } else {
          this.once('runtimeIsPrepared', function () {
            return fn.call(_this5, _this5.options, _this5.context);
          });
        }
      } catch (error) {
        onError && onError(error);
      }

      return this;
    }
    /**
     * Returns a promise which will resolve once the runtime is prepared
     *
     * @returns {PromiseLike<Runtime>}
     * @memberof Runtime
     */

  }, {
    key: "whenPreparedAsync",
    value: function whenPreparedAsync() {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        if (_this6.isPrepared) {
          resolve(_this6);
        } else {
          _this6.once('runtimeIsPrepared', function () {
            return resolve(_this6);
          });
        }
      });
    }
  }, {
    key: "beginTrackingState",

    /**
     * This will get called as part of the initialization sequence
     * @private
     */
    value: function beginTrackingState() {
      var _this7 = this;

      if (this.mainDisposer) {
        return this;
      }

      var mainDisposer = autorun(function () {
        var _this7$events;

        _this7.stateVersion = _this7.stateVersion + 1;
        var currentState = _this7.currentState,
            stateVersion = _this7.stateVersion;

        for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
          args[_key10] = arguments[_key10];
        }

        _this7.emit.apply(_this7, ['change', currentState, stateVersion].concat(args));

        _this7.fireHook.apply(_this7, ['stateDidChange', currentState, stateVersion].concat(args)); // emit an event on the global event bus


        (_this7$events = _this7.events).emit.apply(_this7$events, ['runtimeDidChange', _this7, currentState, stateVersion].concat(args));
      });
      var stateDisposer = this.state.observe(function () {
        var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var currentState = _this7.currentState,
            stateVersion = _this7.stateVersion;

        _this7.fireHook("".concat(update.name, "DidChangeState"), update, currentState, stateVersion);

        _this7.emit('stateWasUpdated', update, currentState, stateVersion);
      });
      this.hide('mainDisposer', function () {
        mainDisposer();
        stateDisposer();
        return _this7;
      });
      return this;
    }
    /**
     * Replace the current state with the new state.  `newState` can be an object or a function which returns the new state
     *
     * @param {Object|Function} [newState={}] - a new object containing the state you wish the runtime to have
     * @param {Function} [cb] - a function we'll call when the state is replaced
     * @returns {Object} the current state after being replaced
     * @memberof Runtime
     * @fires Runtime#stateWillChange
     * @fires Runtime#stateWillReplace
     */

  }, {
    key: "replaceState",
    value: function replaceState() {
      var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cb = arguments.length > 1 ? arguments[1] : undefined;
      var _this$lodash = this.lodash,
          isFunction = _this$lodash.isFunction,
          toPairs = _this$lodash.toPairs;
      /**
       * @event Runtime#stateWillChange
       */

      this.emit('stateWillChange', this.currentState, newState);
      /**
       * @event Runtime#stateWillReplace
       */

      this.emit('stateWillReplace', this.currentState, newState);

      if (isFunction(newState)) {
        newState = newState(this.currentState, this);
      }

      var result = this.state.replace(toPairs(newState));

      if (isFunction(cb)) {
        cb(this.currentState);
      }

      return result;
    }
    /**
     * Replace the current state with the new state
     *
     * @param {Object|Function} [newState={}] - a new object containing the state you wish the runtime to have
     * @param {Function} [cb] - a function we'll call when the state is replaced
     * @returns {Object} the current state after being replaced
     * @memberof Runtime
     * @fires Runtime#stateWillChange
     */

  }, {
    key: "setState",
    value: function setState() {
      var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cb = arguments.length > 1 ? arguments[1] : undefined;
      var _this$lodash2 = this.lodash,
          isFunction = _this$lodash2.isFunction,
          toPairs = _this$lodash2.toPairs;

      if (isFunction(newState)) {
        newState = newState(this.currentState, this);
      }
      /**
       * @event Runtime#stateWillChange
       */


      this.emit('stateWillChange', this.currentState, newState);
      var result = this.state.merge(toPairs(newState));

      if (isFunction(cb)) {
        cb(this.currentState);
      }

      return result;
    }
    /**
     * @abstract
     */

  }, {
    key: "stateDidChange",
    value: function stateDidChange() {}
  }, {
    key: "observe",
    value: function observe(listener) {
      var _this8 = this;

      var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'state';
      return _observe(prop ? this.get(prop) : this, function (change) {
        return listener.call(_this8, change);
      });
    }
  }, {
    key: "makeObservable",
    value: function makeObservable() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var target = arguments.length > 1 ? arguments[1] : undefined;
      target = target || this;
      properties = omitBy(properties, function (val, key) {
        return _lodash["default"].has(target, key);
      }); // WOW clean this up
      // prettier-ignore

      return extendObservable(target, mapValues(properties, function (val) {
        if (!isArray(val)) {
          return val;
        }

        var _val = (0, _slicedToArray2["default"])(val, 2),
            observableType = _val[0],
            initialValue = _val[1];

        var f = observable[observableType];

        if (observableType !== 'action' && observableType !== 'computed' && !f) {
          throw new Error("Invalid Observable: ".concat(observableType));
        }

        if (observableType === "map" && isObject(initialValue)) {
          return f(toPairs(initialValue));
        } else if (observableType === "shallowMap" && isObject(initialValue)) {
          return f(toPairs(initialValue));
        } else if (observableType === "object") {
          return f(val[1] || {});
        } else if (observableType === "shallowObject") {
          return f(val[1] || {});
        } else if (observableType === "shallowArray") {
          return f(val[1] || []);
        } else if (observableType === "array") {
          return f(val[1] || []);
        } else if (observableType === "struct") {
          return f(val[1] || []);
        } else if (observableType === "computed" && isFunction(initialValue)) {
          return computed(val[1].bind(target));
        } else if (observableType === "action" && isFunction(initialValue)) {
          return action(val[1].bind(target));
        } else {
          return val;
        }
      }));
    }
  }, {
    key: "createObservable",
    value: function createObservable() {
      var _this9 = this;

      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var observerFn = arguments.length > 1 ? arguments[1] : undefined;
      var scope = arguments.length > 2 ? arguments[2] : undefined;
      var instance = observable(properties);

      if (observerFn) {
        var disposer = _observe(instance, function (change) {
          return observerFn.call(scope || instance, change, instance, _this9.context);
        });

        hide(instance, 'cancelObserver', function () {
          disposer();
          return instance;
        });
      }

      hide(instance, 'toJS', function () {
        return toJS(instance);
      });
      return instance;
    }
  }, {
    key: "observeState",
    value: function observeState(handler) {
      return this.state.observe(handler);
    }
  }, {
    key: "interceptState",
    value: function interceptState(handler) {
      return this.state.intercept(handler);
    }
  }, {
    key: "convertToJS",
    value: function convertToJS() {
      return toJS.apply(void 0, arguments);
    }
    /**
     * This function is a hook that gets called by the helper.createInstance lifecycle
     *
     * I believe i originally had this setup as a hook on runtime so that, either:
     *
     *  1) runtime could be in control of what observability means, and the helpers just expect an interface to it
     *  2) as a form of code splitting? since runtime has the mobx dependency bundled with it, and we want to be able to export a small helper class?
     *
     * This hook decorates the instance of the helper with mobx observable properties, which includes
     * observable objects, actions, and computed attribute getters
     */

  }, {
    key: "didCreateObservableHelper",
    value: function didCreateObservableHelper(helperInstance, helperClass) {
      if (helperInstance.tryGet('observables')) {
        var observables = helperInstance.tryResult('observables', {});
        this.makeObservable(observables, helperInstance);
      }

      if (!helperInstance.has('state')) {
        makeStateful(helperInstance);
      } // can't think of any classes which define it as a static property


      if (helperClass.observables) {
        var _observables = isFunction(helperClass.observables) ? helperClass.observables.call(helperInstance, helperInstance.options, helperInstance.context, helperInstance) : helperClass.observables;

        this.makeObservable(_observables, helperInstance);
      }

      Promise.resolve(helperInstance.setInitialState());
    }
  }, {
    key: "isFeatureEnabled",

    /**
     * Tells you if a feature is enabled or not.
     *
     * @param {String} name
     * @returns {Boolean}
     * @memberof Runtime#
     */
    value: function isFeatureEnabled(name) {
      var item = this.featureStatus.get(name);

      if (!item) {
        return false;
      }

      if (item && item.status === 'enabled') {
        return true;
      }

      return false;
    }
    /**
     * Enable multiple features at a time
     *
     * @param {*} [options={}]
     * @returns
     * @memberof Runtime
     */

  }, {
    key: "enableFeatures",
    value: function enableFeatures() {
      var _this10 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var availableFeatures = this.availableFeatures;

      if (typeof options === 'string' || typeof options === 'undefined') {
        options = [options].filter(function (v) {
          return v;
        });
      }

      if (isArray(options)) {
        options = options.reduce(function (memo, val) {
          if (typeof val === 'string') {
            memo[val] = {};
          } else if (isArray(val)) {
            memo[val[0]] = val[1];
          } else {}

          return memo;
        }, {});
      }

      return mapValues(pick(options, availableFeatures), function (cfg, id) {
        var feature;

        try {
          if (_this10.features.checkKey(id)) {
            feature = _this10.feature(id);
          } else if (_this10.constructor.features.available.indexOf(id) >= 0) {
            feature = _this10.feature(id, {
              provider: _this10.constructor.features.lookup(id)
            });
          }

          feature.enable(cfg);

          _this10.fireHook('featureWasEnabled', feature, _this10);

          _helper.Helper.attachAll(_this10, _this10.helperOptions);

          return feature;
        } catch (error) {
          _this10.fireHook('featureFailedToEnable', feature, error);

          return error;
        }
      });
    }
    /**
     * Runs a life cycle hook method on the runtime. A hook method can either be
     * a standard instance method on runtime, and if one does not exist, an event is
     * also emitted by the same name
     *
     * @param {String} hookName the name of the hook method
     * @param {...*} args any args you want to pass to the hook
     * @returns {Runtime}
     * @memberof Runtime#
     * @emits Runtime#firingHook
     */

  }, {
    key: "fireHook",
    value: function fireHook(hookName) {
      var _this$runtimeEvents;

      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }

      if (this.argv.debugHooks) {
        this.debug("Firing Hook", {
          hookName: hookName,
          argsLength: args.length
        });
      }

      var fnHandler = this.get(['options', hookName], this.get(hookName));

      (_this$runtimeEvents = this.runtimeEvents).emit.apply(_this$runtimeEvents, ["runtime:".concat(hookName), this].concat(args));

      this.emit.apply(this, ["firingHook", hookName].concat(args));
      this.emit.apply(this, [hookName].concat(args));

      if (fnHandler) {
        try {
          fnHandler.call.apply(fnHandler, [this].concat(args));
        } catch (error) {
          this.argv.debugHooks && this.error("Error while firing hook: ".concat(hookName), {
            error: error.message
          });
          this.emit('hookError', hookName, error);
        }
      } else {
        if (this.argv.debugHooks) {
          this.debug("No hook named ".concat(hookName, " present"));
        }
      }

      return this;
    }
    /**
     * Returns the base Feature class that the runtime uses.  You shouldn't need to change this,
     * however you can use one class in production and another in dev / test if you want to,
     *
     * @readonly
     * @type {Class}
     * @memberof Runtime#
     */

  }, {
    key: "feature",

    /**
     * Create an instance of a Feature from one of the available Feature providers in the registry.
     *
     * Calling this method more than once with the same options, will return the same object, unless that
     * Helper class or the registry it is a part sets isCacheable = false
     *
     * @param {String} featureModuleId
     * @param {Object} [options={}]
     * @param {Object} [context={}]
     * @returns {Feature}
     * @memberof Runtime
     */
    value: function feature(featureModuleId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._feature(featureModuleId, options, context);
    }
    /**
     * Provides access to the Feature helper's registry
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "createRegistry",
    value: function createRegistry(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var registry = _helper.Helper.createRegistry(name, (0, _objectSpread2["default"])({
        context: _helper.Helper.createMockContext({})
      }, options));

      this.fireHook('registryWasCreated', name, registry, options);
      return registry;
    }
  }, {
    key: "createSandbox",
    value: function createSandbox() {
      var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _objectSpread2["default"])({
        // all aliases i've used over time for the same thing. should deprecrate them gracefully
        project: this,
        runtime: this,
        skypager: this,
        host: this,
        propUtils: propUtils,
        stringUtils: stringUtils,
        urlUtils: urlUtils,
        mobx: mobx,
        lodash: _lodash["default"],
        currentState: this.currentState
      }, this.featureRefs, ctx);
    }
    /**
     * Returns an md5 hash for any JavaScript object
     *
     * @param {Object} anyObject - any object you want to calculate a unique hash for
     */

  }, {
    key: "hashObject",
    value: function hashObject(anyObject) {
      return _hashObject(anyObject);
    }
    /**
     * Creates an entity object from any slice of runtime properties / values
     */

  }, {
    key: "createEntityFrom",
    value: function createEntityFrom() {
      var src = this.slice.apply(this, arguments);
      return entity(toJS(src));
    }
    /**
     * Select a slice of state using a list of object paths, can be multiple levels deep a.b.c
     *
     * @param {*} properties - an array of strings representing object paths
     * @returns {*}
     * @memberof Runtime
     */

  }, {
    key: "slice",
    value: function slice() {
      for (var _len12 = arguments.length, properties = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        properties[_key12] = arguments[_key12];
      }

      return toJS(zipObjectDeep(properties, this.at(properties)));
    }
    /**
     * Fetch a object from runtime.options or runtime.context
     *
     * If the method is a function, it will be called in the scope of the helper,
     * with the helpers options and context
     *
     * @param {String} objectPath the dot.path to the property
     * @param {*} defaultValue the default value
     * @memberof Runtime
     */

  }, {
    key: "tryGet",
    value: function tryGet(property, defaultValue) {
      return this.at("options.".concat(property), "context.".concat(property)).filter(function (v) {
        return typeof v !== 'undefined';
      })[0] || defaultValue;
    }
    /**
     * Fetch a object from runtime.options or runtime.context
     *
     * If the method is a function, it will be called in the scope of the helper,
     * with the helpers options and context
     *
     * @param {String} objectPath the dot.path to the property
     * @param {*} defaultValue the default value
     * @param {Object} options options object which will be passed to the property if it is a function
     * @param {Object} context context object which will be passed to the property if it is a function
     * @returns {*}
     * @memberof Helper
     */

  }, {
    key: "tryResult",
    value: function tryResult(property, defaultValue) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var val = this.tryGet(property);

      if (!val) {
        return typeof defaultValue === 'function' ? defaultValue.call(this, (0, _objectSpread2["default"])({}, this.options, options), (0, _objectSpread2["default"])({}, this.context, context)) : defaultValue;
      } else if (typeof val === 'function') {
        return val.call(this, (0, _objectSpread2["default"])({}, this.options, options), (0, _objectSpread2["default"])({}, this.context, context));
      } else {
        return val;
      }
    } // Merge the objects found at k starting with at options, provider, projectConfig

  }, {
    key: "mergeGet",
    value: function mergeGet(key) {
      var _this11 = this;

      var namespaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['options', 'argv', 'config'];
      key = typeof key === 'string' ? key.split('.') : key;
      key = flatten(castArray(key));
      return defaults.apply(void 0, [{}].concat((0, _toConsumableArray2["default"])(namespaces.map(function (n) {
        return _this11.get([n].concat((0, _toConsumableArray2["default"])(key)));
      }))));
    } // Merge the objects found at k starting with at options, provider, projectConfig
    // If the property is a function, it will be called in the scope of the helper, with the helpers options and context

  }, {
    key: "mergeResult",
    value: function mergeResult(key) {
      var _this12 = this;

      var namespaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['options', 'argv', 'config'];
      key = typeof key === 'string' ? key.split('.') : key;
      key = flatten(castArray(key));

      var ifFunc = function ifFunc(v) {
        return typeof v === 'function' ? v.call(_this12, _this12.options, _this12.context) : v;
      };

      return defaults.apply(void 0, [{}].concat((0, _toConsumableArray2["default"])(namespaces.map(function (n) {
        return _this12.get([n].concat((0, _toConsumableArray2["default"])(key)));
      }).map(ifFunc))));
    }
    /**
     * Runs a selector function by first checking against the selectorCache
     *
     * @param {*} selectorId
     * @param {*} args
     * @returns {PromiseLike<*>}
     * @memberof Runtime
     */

  }, {
    key: "selectCached",
    value: function () {
      var _selectCached = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee3(selectorId) {
        var _len13,
            args,
            _key13,
            _args3 = arguments;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.selectorCache.get(selectorId)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", this.selectorCache.get(selectorId));

              case 2:
                for (_len13 = _args3.length, args = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
                  args[_key13 - 1] = _args3[_key13];
                }

                return _context3.abrupt("return", this.select.apply(this, [selectorId].concat(args)));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function selectCached(_x) {
        return _selectCached.apply(this, arguments);
      }

      return selectCached;
    }()
    /**
     * Runs an async selector function from the registry.
     *
     * A selector function will be passed an instance of `lodash.chain({Runtime})` and should return that chain.
     *
     * @param {String} selectorId a selector function that exists in the selectors registry
     * @param {*} args
     * @returns {PromiseLike<*>}
     * @memberof Runtime
     * @example @lang js
     *
     * runtime.selectors.register('something', () => async (chain, eachItem) => {
     *  const results = await doStuff()
     *  return chain
     *    .plant(results)
     *    .groupBy('column')
     *    .mapValues((groupName, items) => items.map(eachItem))
     * })
     *
     * const value = await runtime.select('something', (item) => item + 1)
     */

  }, {
    key: "select",
    value: function () {
      var _select = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee4(selectorId) {
        var _selector;

        var selector,
            _len14,
            args,
            _key14,
            result,
            _args4 = arguments;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                selector = this.selectors.lookup(selectorId);
                selector = isFunction(selector["default"]) ? selector["default"] : selector;

                for (_len14 = _args4.length, args = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
                  args[_key14 - 1] = _args4[_key14];
                }

                _context4.next = 5;
                return (_selector = selector).call.apply(_selector, [this, this.chain].concat(args));

              case 5:
                result = _context4.sent;
                return _context4.abrupt("return", isFunction(result.value) ? result.value() : result);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function select(_x2) {
        return _select.apply(this, arguments);
      }

      return select;
    }()
    /**
     * Same as `select` but accepts passing a function as the last argument.
     * This function will be called with the result of the selector function
     *
     * @param {String} selectorId a selector function that exists in the selectors registry
     * @param {*} args args to pass thru to the function. the last argument should be a function.
     * @memberof Runtime
     * @returns {PromiseLike<*>}
     */

  }, {
    key: "selectThru",
    value: function () {
      var _selectThru = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee5(selectorId) {
        var _len15,
            args,
            _key15,
            fn,
            response,
            _args5 = arguments;

        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                for (_len15 = _args5.length, args = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
                  args[_key15 - 1] = _args5[_key15];
                }

                fn = args.length && typeof args[args.length - 1] === 'function' ? args[args.length - 1] : this.lodash.identity;
                _context5.next = 4;
                return this.selectChain.apply(this, [selectorId].concat(args));

              case 4:
                response = _context5.sent;
                return _context5.abrupt("return", response.thru(fn).value());

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function selectThru(_x3) {
        return _selectThru.apply(this, arguments);
      }

      return selectThru;
    }()
    /**
     * Same as `selectThru` but returns the resulting lodash chain still in chain mode
     *
     * @param {string} selectorId the id of the registered selector function
     * @param {...*} args args to pass thru to the selector.  if the last arg is a function
     *                    it will receive the value as a lodash chain.thru()
     * @returns {LodashChain}
     */

  }, {
    key: "selectChainThru",
    value: function () {
      var _selectChainThru = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee6(selectorId) {
        var _len16,
            args,
            _key16,
            fn,
            response,
            _args6 = arguments;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                for (_len16 = _args6.length, args = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
                  args[_key16 - 1] = _args6[_key16];
                }

                fn = args.length && typeof args[args.length - 1] === 'function' ? args[args.length - 1] : this.lodash.identity;
                _context6.next = 4;
                return this.selectChain.apply(this, [selectorId].concat(args));

              case 4:
                response = _context6.sent;
                return _context6.abrupt("return", response.thru(fn));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function selectChainThru(_x4) {
        return _selectChainThru.apply(this, arguments);
      }

      return selectChainThru;
    }()
    /**
     * Same as `select` but returns the resulting lodash chain still in chain mode.
     *
     * @param {String} selectorId a selector function that exists in the selectors registry
     * @param {*} args arguments to be passed thru to the selector function
     * @returns {PromiseLike<*>}
     */

  }, {
    key: "selectChain",
    value: function () {
      var _selectChain = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee7(selectorId) {
        var _len17,
            args,
            _key17,
            results,
            _args7 = arguments;

        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                for (_len17 = _args7.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
                  args[_key17 - 1] = _args7[_key17];
                }

                _context7.next = 3;
                return this.select.apply(this, [selectorId].concat(args));

              case 3:
                results = _context7.sent;
                return _context7.abrupt("return", _lodash["default"].chain(results));

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function selectChain(_x5) {
        return _selectChain.apply(this, arguments);
      }

      return selectChain;
    }()
    /**
     * @returns {Runtime} the runtime singleton
     */

  }, {
    key: "uuid",
    get: function get() {
      return this._uuid;
    }
  }, {
    key: "cwd",
    get: function get() {
      return this._cwd;
    }
  }, {
    key: "name",
    get: function get() {
      return this._name;
    },
    set: function set(val) {
      this.hide('_name', val, true);
    }
  }, {
    key: "logger",
    get: function get() {
      return this._logger;
    }
  }, {
    key: "cache",
    get: function get() {
      return this._cache;
    }
  }, {
    key: "selectors",
    get: function get() {
      return this._selectors;
    }
  }, {
    key: "selectorCache",
    get: function get() {
      return selectorCache.get(this);
    }
    /**
     * Yo dawg, I heard you like registries so here's a registry for your registries.
     *
     * @type {ContextRegistry}
     * @readonly
     * @memberof Runtime
     */

  }, {
    key: "registries",
    get: function get() {
      return this._registries;
    }
    /**
     * Returns a lodash chain object, using this helper instance as the source value
     *
     * @readonly
     * @memberof Helper
     */

  }, {
    key: "chain",
    get: function get() {
      return _lodash["default"].chain(this);
    }
  }, {
    key: "contextTypes",

    /**
     * Returns the contextTypes declarations for our Runtime class.
     *
     * @readonly
     * @memberof Runtime
     */
    get: function get() {
      return defaults({}, _result('constructor.contextTypes'), {
        lodash: 'func',
        runtime: 'object',
        skypager: 'object',
        host: 'object',
        project: 'object'
      });
    }
    /**
     * the optionTypes declarations for our Runtime class
     *
     * @readonly
     * @memberof Runtime
     */

  }, {
    key: "optionTypes",
    get: function get() {
      return _result(this.constructor, 'optionTypes', {});
    }
    /**
     * Returns the default context value for this runtime
     *
     * @readonly
     * @memberof Runtime
     */

  }, {
    key: "defaultContext",
    get: function get() {
      return _result(this.constructor, 'defaultContext', {});
    }
    /**
     * Returns the default options for this runtime
     *
     * @readonly
     * @memberof Runtime
     */

  }, {
    key: "defaultOptions",
    get: function get() {
      return defaults({}, _get(this, 'projectConfig'), _result(this.constructor, 'defaultOptions'), // Find some way to be able to inject ARGV in projects which consume skypager via webpack
      global.SKYPAGER_ARGV, global.ARGV);
    }
  }, {
    key: "optionsWithDefaults",
    get: function get() {
      return defaults({}, this.rawOptions, this.defaultOptions);
    }
  }, {
    key: "strictMode",
    get: function get() {
      return !!_get(this, 'rawOptions.strictMode', this.constructor.strictMode);
    }
    /**
     * @readonly
     * @memberof Runtime
     *
     * The options are what the runtime was initialized with.  Runtimes can be strict about which options they accept.
     */

  }, {
    key: "options",
    get: function get() {
      return this.strictMode ? pick(this.optionsWithDefaults, keys(this.optionTypes)) : this.optionsWithDefaults;
    }
  }, {
    key: "context",
    get: function get() {
      return defaults({}, pick(this.rawContext, keys(this.contextTypes)), this.defaultContext, {
        runtime: this,
        lodash: this.lodash
      }, pick(global, keys(this.contextTypes)));
    }
  }, {
    key: "initializers",
    get: function get() {
      return this.constructor.initializers || Runtime.initializers;
    }
  }, {
    key: "runtimes",
    get: function get() {
      return this.constructor.runtimes || Runtime.runtimes;
    }
    /**
     * @type {EventEmitter}
     */

  }, {
    key: "autoInitialize",
    get: function get() {
      return this.at('argv.autoInitialize', 'constructor.autoInitialize').find(function (v) {
        return typeof v !== 'undefined';
      }) !== false;
    }
  }, {
    key: "autoPrepare",
    get: function get() {
      return this.at('argv.autoPrepare', 'constructor.autoPrepare').find(function (v) {
        return typeof v !== 'undefined';
      }) !== false;
    }
  }, {
    key: "autoEnabledFeatures",
    get: function get() {
      var _this13 = this;

      var _this$helperTags = this.helperTags,
          helperTags = _this$helperTags === void 0 ? [] : _this$helperTags;
      return this.chain // whatever our constructor defines
      .get('constructor.autoEnable', {}).keys().concat(this.chain.get('config.features', {}).pickBy(function (v) {
        return v && v.disabled !== true && v.enabled !== false && v.disable !== true && v.enable !== false;
      }).keys().value()) // plus whatever features are already available whose name matches a helper tag prefix
      .concat(this.availableFeatures.filter(function (id) {
        return helperTags.find(function (tag) {
          return id.indexOf(tag) === 0;
        });
      })) // plus whatever features are requested in the options passed to our constructor
      .concat(castArray(this.get('argv.enable', []))).flatten().uniq().reject(function (featureId) {
        return _this13.availableFeatures.indexOf(featureId) === -1;
      }).value();
    }
  }, {
    key: "runtimeInitializers",
    get: function get() {
      var runtime = this;
      var initializers = runtime.initializers,
          tags = runtime.helperTags;
      var pickBy = this.lodash.pickBy;
      return pickBy(initializers.allMembers(), function (fn, id) {
        return !!tags.find(function (tag) {
          return id.indexOf(tag) === 0;
        });
      });
    }
  }, {
    key: "url",
    get: function get() {
      return this.isBrowser ? window.location : urlUtils.parse("file://".concat(this.cwd));
    }
    /**
      argv will refer to the initial options passed to the runtime, along with any default values that have been set
    */

  }, {
    key: "argv",
    get: function get() {
      return this.get('rawOptions', {});
    },
    set: function set(val) {
      this.set('rawOptions', (0, _objectSpread2["default"])({}, this.rawOptions, val));
    }
  }, {
    key: "env",
    get: function get() {
      if (this.isTest) return 'test';
      if (this.isDevelopment) return 'development';
      if (this.isProduction) return 'production';
      return 'development';
    }
    /**
     * Based on the detected or specified platform the Runtime thinks it is in,
     * target will give us its name.  This can be used to auto-discover and register certain
     * helpers and features.
     *
     * @type {String}
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "target",
    get: function get() {
      var _this$argv = this.argv,
          universal = _this$argv.universal,
          target = _this$argv.target;
      if (universal) return 'universal';
      if (target) return target;
      if (this.isElectron) return 'electron';
      if (this.isNode) return 'node';
      if (this.isBrowser) return 'web';
      if (this.isReactNative) return 'native';
      return 'node';
    }
    /**
     * Returns a list of tags that can be used to filter all of the available helpers and features
     * to only those whose registry id or alias includes one of the tags.
     *
     * @type {Array<String>}
     * @readonly
     * @memberof Runtime#
     *
     * @example
     *
     *  runtime.helperTags // => ['development', 'development/node', 'node', 'node/development', 'universal']
     */

  }, {
    key: "helperTags",
    get: function get() {
      return this.get('options.helperTags', [this.env, "".concat(this.env, "/").concat(this.target), this.target, "".concat(this.target, "/").concat(this.env), 'universal']);
    }
    /**
     * Returns true if the runtime is running inside of a browser.
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isBrowser",
    get: function get() {
      return windowIsAvailable && documentIsAvailable;
    }
    /**
     * Returns true if the runtime is running inside of node.
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isNode",
    get: function get() {
      try {
        var isNode = Object.prototype.toString.call(global.process) === '[object process]';
        return isNode;
      } catch (e) {
        return processIsAvailable && (process.title === 'node' || "".concat(process.title).endsWith('.exe'));
      }
    }
    /**
     * Returns true if running node in windows
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isWindows",
    get: function get() {
      return this.isNode && "".concat(process.title).endsWith('.exe');
    }
    /**
     * Returns true if the runtime is running inside of electron
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isElectron",
    get: function get() {
      return processIsAvailable && !isUndefined(process.type) && !isUndefined(process.title) && (process.title.match(/electron/i) || process.versions['electron']);
    }
    /**
     * Returns true if the runtime is running inside of electron's renderer process
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isElectronRenderer",
    get: function get() {
      return !isUndefined(process) && process.type === 'renderer' && windowIsAvailable && documentIsAvailable;
    }
    /**
     * Returns true if the runtime is running inside of React-Native
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isReactNative",
    get: function get() {
      try {
        return !isUndefined(global) && typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
      } catch (error) {
        return false;
      }
    }
    /**
     * Returns true if the process was started with a debug flag
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isDebug",
    get: function get() {
      var _this$argv2 = this.argv,
          argv = _this$argv2 === void 0 ? {} : _this$argv2;
      return !!argv.debug || argv.debugBrk || argv.inspect || argv.inspectBrk;
    }
    /**
     * Returns true if the runtime is running in node process and common CI environment variables are detected
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isCI",
    get: function get() {
      return this.isNode && (process.env.CI || process.env.JOB_NAME && process.env.BRANCH_NAME);
    }
    /**
     * returns true when running in a process where NODE_ENV is set to development, or in a process started with the development flag
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isDevelopment",
    get: function get() {
      var _this$argv3 = this.argv,
          argv = _this$argv3 === void 0 ? {} : _this$argv3;
      return !this.isProduction && !this.isTest && (argv.env === 'development' || process.env.NODE_ENV === 'development');
    }
    /**
     * returns true when running in a process where NODE_ENV is set to test, or in a process started with the test flag
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isTest",
    get: function get() {
      var _this$argv4 = this.argv,
          argv = _this$argv4 === void 0 ? {} : _this$argv4;
      return argv.env === 'test' || process.env.NODE_ENV === 'test';
    }
    /**
     * returns true when running in a process where NODE_ENV is set to production, or in a process started with the test flag
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "isProduction",
    get: function get() {
      var argv = this.argv;
      return argv.env === 'production' || process.env.NODE_ENV === 'production';
    }
  }, {
    key: "initialState",
    get: function get() {
      return defaults({
        stage: 'CREATED'
      }, this.get('argv.initialState'), global.__INITIAL_STATE__, _result(global, 'SkypagerInitialState'), this.constructor.initialState);
    }
  }, {
    key: "stage",
    get: function get() {
      return this.get('currentState.stage');
    }
  }, {
    key: "isInitialized",
    get: function get() {
      return this.get('currentState.initialized', false);
    }
  }, {
    key: "isFailed",
    get: function get() {
      return this.stage === START_FAILURE;
    }
  }, {
    key: "isPrepared",
    get: function get() {
      return this.get('currentState.prepared', this.isRunning || this.isStarted);
    }
  }, {
    key: "isRunning",
    get: function get() {
      return this.get('currentState.started', false);
    }
  }, {
    key: "isStarted",
    get: function get() {
      return this.get('currentState.started', false);
    }
  }, {
    key: "mobx",
    get: function get() {
      return this.constructor.mobx;
    }
  }, {
    key: "observableMap",
    get: function get() {
      return observable.map;
    }
  }, {
    key: "lodash",
    get: function get() {
      return _lodash["default"];
    }
  }, {
    key: "pathUtils",
    get: function get() {
      return pathUtils;
    }
  }, {
    key: "stringUtils",
    get: function get() {
      return stringUtils;
    }
  }, {
    key: "propUtils",
    get: function get() {
      return propUtils;
    }
  }, {
    key: "urlUtils",
    get: function get() {
      return urlUtils;
    }
  }, {
    key: "Runtime",
    get: function get() {
      return Runtime;
    }
  }, {
    key: "BaseRuntime",
    get: function get() {
      return Runtime;
    }
  }, {
    key: "helperEvents",
    get: function get() {
      return _helper.Helper.events;
    }
  }, {
    key: "runtimeEvents",
    get: function get() {
      return events;
    }
    /**
     * Provides access to the global event bus shared by all runtime or helper instances
     *
     * @readonly
     * @memberof Runtime
     */

  }, {
    key: "events",
    get: function get() {
      return events;
    }
    /**
     * Creates a context variable that can be pass down to helpers, or used with the VM
     * to run scripts or modules in an arbitrary global scope
     *
     * @readonly
     * @memberof Runtime
     */

  }, {
    key: "sandbox",
    get: function get() {
      return this.createSandbox(this.context);
    }
    /**
     * Gets the ids of all of the features that are available in the runtime's feature registry,
     * as well as any features that are part of the runtime's class level feature registry.
     * @type {Array<String>}
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "availableFeatures",
    get: function get() {
      var mine = this.get('features.available', []);
      var constructors = this.get('constructor.features.available', []);
      return uniq([].concat((0, _toConsumableArray2["default"])(mine), (0, _toConsumableArray2["default"])(constructors)));
    }
    /**
     * Returns an object the features that are enabled.  The keys are going to be
     * the registry id of that feature, and the values will be the feature helper instance
     *
     * @type {Object<String, Feature>}
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "enabledFeatures",
    get: function get() {
      var _this14 = this;

      return this.chain.invoke('featureStatus.toJSON').pickBy(function (v) {
        return v.status === 'enabled';
      }).mapValues(function (v) {
        return _this14.cache.get(v.cacheKey);
      }).omitBy(function (v) {
        return !v;
      }).value();
    }
    /**
     * Returns the ids of the features that are enabled.
     *
     * @type {Array<String>}
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "enabledFeatureIds",
    get: function get() {
      var keys = this.lodash.keys;
      return keys(this.enabledFeatures);
    }
    /**
     * Returns an object of the enabled features, the keys will be the shortcut property
     * that is defined on the feature.  If the feature does not define one, then it won't
     * show up here.
     *
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "featureRefs",
    get: function get() {
      var _this$lodash3 = this.lodash,
          mapKeys = _this$lodash3.mapKeys,
          omitBy = _this$lodash3.omitBy,
          isEmpty = _this$lodash3.isEmpty;
      var enabledFeatures = this.enabledFeatures;
      var withShortcuts = mapKeys(enabledFeatures, function (feature) {
        return feature.tryGet('shortcut', feature.tryGet('createGetter'));
      });
      return omitBy(withShortcuts, function (v, k) {
        return isEmpty(k);
      });
    }
  }, {
    key: "helpers",

    /**
     * Provides access to the Helper registry
     *
     * @readonly
     * @memberof Runtime
     */
    get: function get() {
      return this.Helper.registry;
    }
    /**
     * Provides access to all of the Helper classes that have been registered
     *
     * @readonly
     * @memberof Runtime
     */

  }, {
    key: "allHelpers",
    get: function get() {
      return this.Helper.allHelpers;
    }
    /**
     * The default options that will be passed to Helper.attach.
     *
     * @type {import("./helper").HelperAttachOptions}
     * @readonly
     * @memberof Runtime#
     */

  }, {
    key: "helperOptions",
    get: function get() {
      return this.get('options.helperOptions', this.get('context.helperOptions', {}));
    }
    /**
     * Returns the base Feature class that the runtime uses.  You shouldn't need to change this,
     * however you can use one class in production and another in dev / test if you want to,
     *
     * @type {Class}
     * @memberof Runtime#
     */

  }, {
    key: "features",
    get: function get() {
      return this._features || _feature.Feature.registry;
    }
  }, {
    key: "namespace",
    get: function get() {
      return this.get('options.namespace', 'runtime');
    }
  }], [{
    key: "spawn",
    value: function spawn() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fn = arguments.length > 2 ? arguments[2] : undefined;
      return new Runtime(options, context, fn);
    }
  }, {
    key: "attachEmitter",
    value: function attachEmitter() {
      return _emitter.attachEmitter.apply(void 0, arguments);
    }
  }, {
    key: "registerRuntime",
    value: function registerRuntime(name, runtimeClass) {
      Runtime.runtimes.register(name, function () {
        return runtimeClass;
      });
      return runtimeClass;
    }
  }, {
    key: "registerHelper",
    value: function registerHelper(name, helperClass) {
      _registerHelper(name, function () {
        return helperClass;
      });

      return helperClass;
    }
  }, {
    key: "createSingleton",

    /**
     * @returns {Runtime} the runtime singleton
     */
    value: function createSingleton(options, context, middlewareFn) {
      return singleton = singleton || new this(options, context, middlewareFn);
    }
    /**
     * Access the Helper class, which you can extend to create your own Helpers
     *
     * @static
     * @memberof Runtime
     */

  }, {
    key: "runtimes",
    get: function get() {
      var base = this;

      if (runtimesRegistry) {
        return runtimesRegistry;
      }

      runtimesRegistry = new ContextRegistry('runtimes', {
        context: _helper.Helper.createMockContext(),
        wrapper: function wrapper(fn) {
          return function () {
            for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
              args[_key18] = arguments[_key18];
            }

            return (0, _construct2["default"])(fn, args);
          };
        },
        fallback: function fallback(id) {
          return base || Runtime;
        }
      });
      runtimesRegistry.register('universal', function () {
        return Runtime;
      });
      return runtimesRegistry;
    }
  }, {
    key: "features",
    get: function get() {
      return _feature.Feature.registry;
    }
  }, {
    key: "framework",
    get: function get() {
      return frameworkRuntime = frameworkRuntime || this.createSingleton();
    }
  }]);
  return Runtime;
}();

exports.Runtime = Runtime;
(0, _defineProperty2["default"])(Runtime, "contextTypes", contextTypes);
(0, _defineProperty2["default"])(Runtime, "optionTypes", optionTypes);
(0, _defineProperty2["default"])(Runtime, "defaultContext", defaultContext);
(0, _defineProperty2["default"])(Runtime, "defaultOptions", defaultOptions);
(0, _defineProperty2["default"])(Runtime, "strictMode", enableStrictMode.toString() !== 'false');
(0, _defineProperty2["default"])(Runtime, "initializers", new ContextRegistry('initializers', {
  context: _helper.Helper.createMockContext(),
  useDefaultExport: true
}));
(0, _defineProperty2["default"])(Runtime, "events", events);
(0, _defineProperty2["default"])(Runtime, "autoEnable", {
  vm: {}
});
(0, _defineProperty2["default"])(Runtime, "initialState", {});
(0, _defineProperty2["default"])(Runtime, "ContextRegistry", ContextRegistry);
(0, _defineProperty2["default"])(Runtime, "Helper", _helper.Helper);
(0, _defineProperty2["default"])(Runtime, "mobx", mobx);
(0, _defineProperty2["default"])(Runtime, "observableMap", observable.map);
(0, _defineProperty2["default"])(Runtime, "lodash", _lodash["default"]);
(0, _defineProperty2["default"])(Runtime, "pathUtils", pathUtils);
(0, _defineProperty2["default"])(Runtime, "stringUtils", stringUtils);
(0, _defineProperty2["default"])(Runtime, "propUtils", propUtils);
(0, _defineProperty2["default"])(Runtime, "urlUtils", urlUtils);
(0, _defineProperty2["default"])(Runtime, "Helper", _helper.Helper);
(0, _defineProperty2["default"])(Runtime, "Feature", _feature.Feature);
(0, _defineProperty2["default"])(Runtime, "autoConfigs", []);
(0, _defineProperty2["default"])(Runtime, "autoAdd", []);
var createSingleton = Runtime.createSingleton.bind(Runtime);
exports.createSingleton = createSingleton;
var INITIALIZING = 'INITIALIZING';
exports.INITIALIZING = INITIALIZING;
var INITIALIZED = 'INITIALIZED';
exports.INITIALIZED = INITIALIZED;
var PREPARING = 'PREPARING';
exports.PREPARING = PREPARING;
var READY = 'READY';
exports.READY = READY;
var STARTING = 'STARTING';
exports.STARTING = STARTING;
var RUNNING = 'RUNNING';
exports.RUNNING = RUNNING;
var START_FAILURE = 'START_FAILURE';
exports.START_FAILURE = START_FAILURE;
var PREPARE_FAILURE = 'PREPARE_FAILURE';
exports.PREPARE_FAILURE = PREPARE_FAILURE;
var INITIALIZE_FAILURE = 'INITIALIZE_FAILURE';
exports.INITIALIZE_FAILURE = INITIALIZE_FAILURE;
var stages = {
  INITIALIZING: INITIALIZING,
  INITIALIZED: INITIALIZED,
  PREPARING: PREPARING,
  READY: READY,
  STARTING: STARTING,
  RUNNING: RUNNING,
  START_FAILURE: START_FAILURE,
  INITIALIZE_FAILURE: INITIALIZE_FAILURE,
  PREPARE_FAILURE: PREPARE_FAILURE
};
exports.stages = stages;

function initializeSequence(runtime, initializeMethod) {
  if (runtime.isInitialized) return runtime;
  runtime.fireHook('beforeInitialize', runtime);
  runtime.beginTrackingState();
  runtime.setState({
    stage: INITIALIZING,
    initialized: true
  });

  try {
    initializeMethod.call(runtime);
  } catch (error) {
    runtime.setState({
      stage: INITIALIZE_FAILURE,
      error: error
    });
    throw error;
  }

  runtime.fireHook('afterInitialize', runtime);
  runtime.setState({
    stage: INITIALIZED
  });
  events.emit('runtimeDidInitialize', runtime, runtime.constructor);
  runtime.attachAllHelpers();
  if (runtime.autoPrepare !== false) Promise.resolve(runtime.prepare());
  return runtime;
}

function prepareSequence(_x6, _x7) {
  return _prepareSequence.apply(this, arguments);
}

function _prepareSequence() {
  _prepareSequence = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee8(runtime, prepareMethod) {
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!runtime.isPrepared) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return", runtime);

          case 2:
            runtime.setState({
              stage: PREPARING
            });
            runtime.fireHook('preparing');
            _context8.prev = 4;
            _context8.next = 7;
            return this.runMiddleware(PREPARING);

          case 7:
            _context8.next = 14;
            break;

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](4);
            runtime.setState({
              stage: PREPARE_FAILURE,
              error: _context8.t0
            });
            runtime.fireHook('prepareDidFail', _context8.t0);
            throw _context8.t0;

          case 14:
            _context8.prev = 14;

            if (!(typeof runtime.options.prepare === 'function')) {
              _context8.next = 18;
              break;
            }

            _context8.next = 18;
            return Promise.resolve(runtime.options.prepare.call(runtime, runtime.argv, runtime.sandbox));

          case 18:
            _context8.next = 20;
            return prepareMethod.call(runtime, runtime.argv, runtime.sandbox);

          case 20:
            runtime.setState({
              stage: READY,
              prepared: true
            });
            _context8.next = 28;
            break;

          case 23:
            _context8.prev = 23;
            _context8.t1 = _context8["catch"](14);
            runtime.setState({
              stage: PREPARE_FAILURE,
              error: _context8.t1
            });
            runtime.fireHook('prepareDidFail', _context8.t1);
            throw _context8.t1;

          case 28:
            runtime.fireHook('runtimeIsPrepared');
            return _context8.abrupt("return", runtime);

          case 30:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this, [[4, 9], [14, 23]]);
  }));
  return _prepareSequence.apply(this, arguments);
}

function startSequence(_x8, _x9) {
  return _startSequence.apply(this, arguments);
}

function _startSequence() {
  _startSequence = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee9(runtime, startMethod) {
    var beforeHooks;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(runtime.stage === RUNNING)) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return", runtime);

          case 2:
            if (!runtime.isStarted) {
              _context9.next = 4;
              break;
            }

            return _context9.abrupt("return", runtime);

          case 4:
            beforeHooks = runtime.at('options.beforeStart', 'beforeStart', 'options.runtimeWillStart', 'runtimeWillStart').filter(function (f) {
              return typeof f === 'function';
            });
            events.emit('runtimeIsStarting', runtime, runtime.constructor);

            if (!(beforeHooks.length > 0)) {
              _context9.next = 17;
              break;
            }

            _context9.prev = 7;
            _context9.next = 10;
            return Promise.all(beforeHooks.map(function (fn) {
              return fn.call(runtime, runtime.argv, runtime.sandbox);
            }));

          case 10:
            _context9.next = 17;
            break;

          case 12:
            _context9.prev = 12;
            _context9.t0 = _context9["catch"](7);
            events.emit('runtimeStartFailure', _context9.t0, runtime, runtime.constructor);
            runtime.setState({
              stage: START_FAILURE,
              error: _context9.t0,
              failureStage: 'beforeHooks'
            });
            throw _context9.t0;

          case 17:
            _context9.prev = 17;
            runtime.setState({
              stage: STARTING
            });
            _context9.next = 21;
            return this.runMiddleware(STARTING);

          case 21:
            _context9.next = 29;
            break;

          case 23:
            _context9.prev = 23;
            _context9.t1 = _context9["catch"](17);
            events.emit('runtimeFailedStart', _context9.t1, runtime, runtime.constructor);
            runtime.fireHook('runtimeFailedStart', _context9.t1, runtime, runtime.constructor);
            runtime.setState({
              stage: START_FAILURE,
              error: _context9.t1,
              failureStage: 'middlewares'
            });
            throw _context9.t1;

          case 29:
            _context9.prev = 29;
            _context9.next = 32;
            return startMethod.call(runtime, runtime.options);

          case 32:
            _context9.next = 40;
            break;

          case 34:
            _context9.prev = 34;
            _context9.t2 = _context9["catch"](29);
            events.emit('runtimeFailedStart', _context9.t2, runtime, runtime.constructor);
            runtime.setState({
              stage: START_FAILURE,
              error: _context9.t2,
              failureStage: 'startMethod'
            });
            runtime.fireHook('runtimeFailedStart', _context9.t2, runtime, runtime.currentState);
            throw _context9.t2;

          case 40:
            runtime.setState({
              stage: RUNNING,
              started: true
            });
            runtime.fireHook('runtimeDidStart', runtime, runtime.currentState);
            events.emit('runtimeDidStart', runtime, runtime.currentState, runtime.constructor);
            return _context9.abrupt("return", this);

          case 44:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, this, [[7, 12], [17, 23], [29, 34]]);
  }));
  return _startSequence.apply(this, arguments);
}

function makeStateful() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  obj.stateVersion = 0;
  extendObservable(obj, {
    state: observable.shallowMap(toPairs(obj.initialState || {})),
    currentState: computed(function () {
      return obj.state.toJSON();
    })
  });
  autorun(function () {
    var stateVersion = obj.stateVersion = obj.stateVersion + 1;
    var currentState = obj.currentState;
    obj.emit && obj.emit('change', obj, currentState, stateVersion);
    obj.fireHook && obj.fireHook('stateDidChange', currentState, stateVersion);
  });
  obj.state.observe(function () {
    var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    obj.fireHook && obj.fireHook("".concat(update.name, "DidChangeState"), update);

    if (obj.emit) {
      obj.emit('stateDidChange', update);
      obj.emit("".concat(update.name, "DidChangeState"), update);
    }
  }); // obj.getter('currentState', () => obj.state.toJSON())

  return obj;
}

var _default = Runtime;
exports["default"] = _default;